export function initCommandBar() {
  const form = document.querySelector('[data-command-bar]');
  const out = document.querySelector('[data-command-result]');
  if (!form || !out) return;

  const copy = {
    'sdk|lifecycle|saas|both':
      'SDK on the hosted ledger — full lifecycle scans, dual views for operators and agents.',
    'mcp|pii|self|agent':
      'MCP in your perimeter with PII events on every retrieve. Agents inherit redaction; they cannot skip it.',
    'dashboard|audit|saas|human':
      'Operator dashboard with replayable audit. Same structures the tools already consume.',
  };

  const describe = (data) => {
    const key = `${data.surface}|${data.compliance}|${data.deploy}|${data.audience}`;
    return (
      copy[key] ||
      `Surface ${data.surface} · ${data.compliance} · ${data.deploy} · ${data.audience}. Not a bucket wrapper — a ledger you can inspect.`
    );
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries());
    out.textContent = describe(data);
  });
}
